import { Component, Input, OnInit } from '@angular/core';
import { Address, IMultiProductCard } from '@mwe/models';

import { TranslateDirective } from '@ngx-translate/core';
import { AddressComponent } from '../../address/address.component';
import { MultiProductCardContainerComponent } from '../../product-card/multi-product-card/multi-product-card-container.component';

@Component({
  selector: 'mwe-process-summary',
  templateUrl: './process-summary.component.html',
  styles: [],
  imports: [TranslateDirective, AddressComponent, MultiProductCardContainerComponent],
})
export class ProcessSummaryComponent implements OnInit {
  @Input() header: string;
  @Input() description: string;
  @Input() address: Address;
  @Input() processTitle: string;
  @Input() productGroups: string[][];

  multiProductCards: IMultiProductCard[];

  constructor() {}

  ngOnInit(): void {
    if (this.productGroups) {
      this.multiProductCards = this.productGroups.map(group => {
        return { categories: group };
      });
    }
  }
}
